<template>
  <div id="locations-update">
    <wrld-container
      :breadcrumbs="this.breadcrumbs"
      :pageIsLoading="pageIsLoading"
    >
      <v-form
        ref="locationForm"
        v-model="valid"
        lazy-validation
      >
        <LocationForm v-model="location" :isUpdate="isUpdate" :hideContacts="true"/>
        <v-btn class="mr-4" @click="goBack()">{{$t('buttons.cancel')}}</v-btn>
        <v-btn
          @click="callUpdateLocation()"
          :disabled="!valid"
        >{{$t('buttons.save')}}</v-btn>
        <span v-if="!valid" class="red--text">{{$t('general.not_all_required_fields')}}</span>
      </v-form>
    </wrld-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router'
import LocationForm from '@/components/locations/LocationForm.vue'
import { companyService, locationService } from '@/_services'
import { locationHelpers, generalHelpers } from '@/_helpers'

export default {
  name: 'LocationsUpdate',
  components: {
    LocationForm
  },
  data () {
    return {
      valid: true,
      location: {
        overview: {},
        address: {
          address: {},
          coordinates: {}
        },
        opening_hours: [],
        contacts: []
      },
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' }
      ],
      isUpdate: false,
      companyID: null,
      locationID: null
    }
  },
  computed: {
    ...mapState(['route', 'locations'])
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions({
      createLocation: 'createLocation',
      updateLocation: 'updateLocation',
      fetchLocations: 'fetchLocations',
      fetchLocationByID: 'fetchLocationByID',
      showSnackbar: 'showSnackbar'
    }),
    goBack () {
      router.push({ name: 'CompanyDetail', params: { CompanyID: this.companyID } })
    },
    async callUpdateLocation () {
      if (this.$refs['locationForm'].validate()) {
        let location = locationHelpers.transformLocationToApi(this.location)
        let snackMsg = ''
        let snackColor = ''
        if (this.locationID === undefined) {
          try {
            await locationService.createLocationInput(this.companyID, location)
            snackMsg = this.$i18n.t('snackbars.location_created')
            snackColor = 'success'
            this.showSnackbar({ message: snackMsg, color: snackColor })
            router.push({ name: 'Locations' })
          } catch (error) {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'errorr'
            this.showSnackbar({ message: snackMsg, color: snackColor })
            router.push({ name: 'Locations' })
          }
        } else {
          try {
            if (this.fetchedLocation.ref !== location.ref) {
              // FIXME: reference can not be changed (403 returned)
              await locationService.setLocationReferenceInput(this.companyID, this.locationID, location.ref)
            }
            if (this.fetchedLocation.name !== location.name) {
              await locationService.setLocationNameInput(this.companyID, this.locationID, location.name)
            }
            if (this.fetchedLocation.type !== location.type) {
              await locationService.setLocationTypeInput(this.companyID, this.locationID, location.type)
            }
            if (!generalHelpers.isEqual({ address: this.fetchedLocation.address, coordinates: this.fetchedLocation.coordinates }, location.address)) {
              await locationService.setAddressInput(this.companyID, this.locationID, location.address)
            }
            const equipmentsDiff = generalHelpers.arrayDiff(this.fetchedLocation.equipment, location.equipment)
            const accessibilityDiff = generalHelpers.arrayDiff(this.fetchedLocation.accessibility, location.accessibility)
            if (equipmentsDiff.added.length > 0 || equipmentsDiff.removed.length > 0) {
              await locationService.setEquipmentsInput(this.companyID, this.locationID, { add: equipmentsDiff.added, remove: equipmentsDiff.removed })
            }
            if (accessibilityDiff.added.length > 0 || accessibilityDiff.removed.length > 0) {
              await locationService.setAccessibilityInput(this.companyID, this.locationID, { add: accessibilityDiff.added, remove: accessibilityDiff.removed })
            }

            snackMsg = this.$i18n.t('snackbars.location_updated')
            snackColor = 'success'
            this.showSnackbar({ message: snackMsg, color: snackColor })
            router.push({
              name: 'LocationDetail2', // TODO: change
              params: { companyID: this.companyID, locationID: this.locationID }
            })
          } catch (error) {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'error'
            this.showSnackbar({ message: snackMsg, color: snackColor })
            router.push({
              name: 'LocationDetail2', // TODO: change
              params: { companyID: this.companyID, locationID: this.locationID }
            })
          }
        }
      }
    },
    async fetchData () {
      this.pageIsLoading = true

      this.locationID = this.route.params.locationID
      this.companyID = this.route.params.companyID
      this.company = await companyService.getCompany(this.companyID)
      if (this.locationID != null) {
        let location = await locationService.getLocation(this.companyID, this.locationID)
        this.fetchedLocation = JSON.parse(JSON.stringify(location))
        this.fillData(location)
        this.isUpdate = true

        this.breadcrumbs.push({ text: this.company.name, disabled: false, href: '#/companies/' + this.companyID })
        this.breadcrumbs.push({ text: `${this.location.overview.code}: ${this.$i18n.t('buttons.edit')}`, disabled: true })
      } else {
        this.breadcrumbs.push({ text: this.company.name, disabled: false, href: '#/companies/' + this.companyID })
        this.breadcrumbs.push({ text: this.$i18n.tc('locations.location', 1) + ' - ' + this.$i18n.t('buttons.create'), disabled: true })
      }

      this.pageIsLoading = false
    },
    fillData (loc) {
      let overview = {
        code: loc.ref,
        accessibility: loc.accessibility,
        equipment: loc.equipment,
        company: loc.company,
        id: loc.id,
        type: loc.type,
        name: loc.name
      }
      let address = {
        address: loc.address,
        coordinates: loc.coordinates
      }
      this.$set(this.location, 'overview', overview)
      this.$set(this.location, 'address', address)
      this.$set(this.location, 'opening_hours', locationHelpers.transformOpeningHoursFromApi(loc.openingHours))
    }
  }
}
</script>
